import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">
      Créé avec ♥ par <b><a href="https://siin.ci" target="_blank">SIIN - Société Ivoirienne d'Intlligence Numérique</a></b> 2018
    </span>
    <div class="socials">
      <a hidden href="#" target="_blank" class="ion ion-social-github"></a>
      <a hidden href="#" target="_blank" class="ion ion-social-facebook"></a>
      <a hidden href="#" target="_blank" class="ion ion-social-twitter"></a>
      <a hidden href="#" target="_blank" class="ion ion-social-linkedin"></a>
    </div>
  `,
})
export class FooterComponent {
}
